/*=====================================
    NewsProductsGridItem

    Author: Ac
    CreateTime: 2018 / 10 / 25
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React from 'react';
import styled from 'styled-components';
import GLOBAL from 'nonnglobal';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import CupoyImage from 'components/commons/CupoyImage';
/*--------------------------
    Styled
--------------------------*/
const GridItem = styled.li`
    background-color: #FFF;
    border-radius: 3px;
    background: #FFFFFF;
    border: 1px solid #DDD;
`;
const GridItemContent = styled.div`
    display: block;
`;
const Image = styled.div`
    height: 226px;
    background-color: #CCC;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
`;
const TextWrapper = styled.div`
    padding: 20px;
`;
const Text = styled.div`
    text-align: center;
    display: -webkit-box;
    overflow : hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 22px;
    height: 44px;
    font-size: 16px;
    color: #333;
`;
/*--------------------------
    Main Component
--------------------------*/
const NewsProductsGridItem = ({
    productId,
    imageSrc,
    productName,
    product,
}) => (
    <GridItem>
        <CupoySrefView
            stylecomponent={GridItemContent}
            statename={GLOBAL.getProductRouterName(product)}
            params={{ id: productId }}
        >
            <CupoyImage
                isBackgroundImage
                stylecomponent={Image}
                src={imageSrc}
            />
            <TextWrapper>
                <Text>
                    {productName}
                </Text>
            </TextWrapper>
        </CupoySrefView>
    </GridItem>
);

/*--------------------------
    Export
--------------------------*/
export default NewsProductsGridItem;